import { useSyncExternalStore } from 'react';

/** 세션 만료 시각 스토어. API 응답 헤더(X-Session-Expires-At)로 갱신된다. */
let expiresAt: number | null = null;
let absoluteAt: number | null = null;
const listeners = new Set<() => void>();
export function setSessionExpiry(iso: string | null, absoluteIso?: string | null) {
  expiresAt = iso ? new Date(iso).getTime() : null;
  if (absoluteIso !== undefined) absoluteAt = absoluteIso ? new Date(absoluteIso).getTime() : null;
  listeners.forEach((l) => l());
}
export function useSessionExpiry() {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => expiresAt, () => expiresAt);
}
export function getSessionAbsolute() { return absoluteAt; }
